import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dbc7c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basket-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasketItem = _resolveComponent("BasketItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      "move-class": "list-move",
      name: "list",
      tag: "div",
      class: "anim"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
          return (_openBlock(), _createBlock(_component_BasketItem, {
            dir: _ctx.dir,
            class: "product-item",
            productProp: product,
            key: index,
            index: index,
            active: _ctx.activeIndex === index,
            currencySign: _ctx.currencySign ?? '',
            notAvailableProducts: _ctx.notAvailableProducts,
            onClick: ($event: any) => (_ctx.onItemHover(index))
          }, null, 8, ["dir", "productProp", "index", "active", "currencySign", "notAvailableProducts", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}